import { StateCheckItem } from "./statecheck";

export const checkClass: Array<StateCheckItem> = [
    {
        statecode: "AL",
        tags: ["dui", "alcohol"],
        onlyCourt: true,
        message:
            `<strong>Warning:</strong> Alabama does not accept any online alcohol or drug education classes for
court, DMV, probation or other legal requirements. Classes must be taken in person
from their approved provider list. Please contact the Administrative Office of the Courts
in Alabama at <a href='http://www.alacourt.gov/' target = "_blank">http://www.alacourt.gov/</a> or by phone (334)&nbsp;954-5000 for a list of local
            providers or with any questions.`,
    },
    {
        statecode: "CA",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking it for a California DMV requirement.
The State of California does not allow online classes for DUI requirements.
You may be allowed to take our classes for a court requirement.
Please check with your local court for acceptability for your specific case.`,
    },
    {
        statecode: "CO",
        tags: ["alcohol","dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking this for a DUI requirement in the state of Colorado.`,
    },
    {
        statecode: "DC",
        tags: ["dui"],
        onlyCourt: false,
        message:
            "<strong>Warning:</strong> You must take a local in person class certified by the state board of behavioral health. No online classes will be accepted for a DUI requirement.",
    },
    {
        statecode: "FL",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking it for a Florida DMV requirement.
The State of Florida does not allow online classes for DUI requirements.
You may be allowed to take our classes for a court requirement.
Please check with your local court for acceptability for your specific case.`,
    },
    {
        statecode: "GA",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking it for a Georgia DMV requirement. The State of Georgia  does not allow online classes for DUI requirements. You may be allowed to take our classes for a court requirement. Please check with your local court for acceptability for your specific case.`,
    },
    {
        statecode: "IA",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking it for a Iowa DMV requirement.
The State of Iowa does not allow online classes for DUI requirements.
You may be allowed to take our classes for a court requirement.
Please check with your local court for acceptability for your specific case.`,
    },
    {
        statecode: "IA",
        tags: ["alcohol"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking this for a DUI requirement in the state of Iowa.`,
    },
    {
        statecode: "IL",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> If you live in the state of IL and have a requirement in IL to complete a risk reduction class or assessment, you must go through a local provider in your state.
        If you have a requirement in IL but live out of the state, you may be able to complete our programs with prior approval. `,
    },
    {
        statecode: "KY",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> If you live in KY and had a KY DUI offence, 
        in accordance with statute KRS 189A.040, 
        DUI treatment and/or education must be conducted by facilities licensed and regulated 
        by the Kentucky Cabinet for Health and Family Services, 
        and no online programs are accepted. 
        If you live out of the state of KY, you may be able to take this program with prior approval from the Kentucky Dept. of Transportation.`,
    },
    {
        statecode: "MO",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> If you are a resident of the state of Missouri and had a DUI in this state, you must go through a local SATOP provider.`,
    },
    {
        statecode: "MN",
        tags: ["dui20"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> The state of MN does not allow online classes for this 20 hour program requirement. You must take a locally approved Driving with Care program within the state of MN.`,
    },
    {
        statecode: "NC",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking it for a North Carolina DMV requirement.
The State of North Carolina does not allow online classes for DUI requirements.
You may be allowed to take our classes for a court requirement.
Please check with your local court for acceptability for your specific case.`,
    },
    {
        statecode: "NJ",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Do not register for this class if you are taking it for a New Jersey DMV requirement.
The State of New Jersey does not allow online classes for DUI requirements.
You may be allowed to take our classes for a court requirement.
Please check with your local court for acceptability for your specific case.`,
    },
    {
        statecode: "NY",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> The state of NY does not allow online classes to be completed by NY residents.`,
    },
    {
        statecode: "OK",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> If you are taking this class for an Oklahoma requirement, these programs must be completed by a local provider.`,
    },
    {
        statecode: "OR",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> If you are a resident of Oregon and have a DUI requirement, no online classes are allowed. You must go through a state approved provider. If you had a DUI in OR but live out of state, you may be able to take this class with prior approval and submitting the required out of state form.`,
    },
    {
        statecode: "PA",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> The state of PA does not currently allow online classes for DUI requirements.  If you wish to take this class online, you must get prior approval from the DMV before enrolling to ensure it will meet your specific requirements.`,
    },
    {
        statecode: "RI",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> The state of Rhode Island requires classes to be completed in person from their state approved provider list. You may be able to take this class for a court only requirement with prior approval. Please contact http://www.dmv.ri.gov/ for more information.`,
    },
    {
        statecode: "SC",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> The state of South Carolina does not allow online classes for residents of SC to complete for a DMV requirement.  Our programs can often be taken for a court requirement only with prior approval. You must go through a local ADSAP program in your state for a SC DMV requirement if you are a resident of SC.`,
    },
    {
        statecode: "TX",
        zipCodes: [
            "75165",
            "75154",
            "76065",
            "75119",
            "75167",
            "76084",
            "76050",
            "75125",
            "75152",
            "76651",
            "76064",
            "76670",
            "76666",
            "76041",
            "75101",
            "75120",
            "75168",
            "76623",
        ],
        tags: ["dui", "anger"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Ellis County, Texas does not allow online clases. Please consult your local court for a list of their approved providers. If you are taking this class for personal growth and not a court requirement then you are allowed to register.`,
    },
    {
        statecode: "TX",
        tags: ["15hour"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> TX DPS does not currently allow or accept online classes.  If you have a Texas Department of Public Safety requirement, please take your class in person from a locally approved program provider in Texas.`,
    },
    {
        statecode: "WA",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> If you live in WA state and have a WA state drivers license you must go through a local state approved and certified agency. If you wish to complete our online class and live out of state, you must get prior approval before enrolling.`,
    },
    {
        statecode: "WI",
        tags: ["dui"],
        onlyCourt: false,
        message:
            `<strong>Warning:</strong> Wisconsin does not accept online alcohol education/counseling programs for a OWI. You must go through a local provider or an in person class only.  You may be able to take this class for a court requirement with prior approval.`,
    },
];
